import React, { Children } from 'react';

import { GridLegacyProps } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import { LayoutItemCard } from '../../functions/components/LayoutItemCard';
import { LayoutItemRaw } from '../../functions/components/LayoutItemRaw';
import { toLayoutItemProps } from '../../functions/converter/toLayoutItemProps';
import { LayoutProps, CoreLayoutProps } from '../../models/models';
import { LayoutItemProps } from '../LayoutItem';
import { mergeToLayoutItemProps } from '../../functions/converter/mergeToLayoutItemProps';

export function GridLayout({
  children,
  renderChild = LayoutItemCard,
  renderProps,
  cardOptions,
  accordionOptions,
  ...containerProps
}: LayoutProps<GridLegacyProps>): JSX.Element {
  if (!children) {
    return null;
  }

  return (
    <Grid container {...containerProps}>
      {Children.map(children, toLayoutItemProps).map((childProps: LayoutItemProps) => (
        <Grid key={childProps.key} {...childProps.gridItemProps}>
          {renderChild(mergeToLayoutItemProps(accordionOptions, cardOptions, childProps, renderProps))}
        </Grid>
      ))}
    </Grid>
  );
}

export const RawGridLayout = (props: CoreLayoutProps<GridLegacyProps>): JSX.Element => {
  return <GridLayout {...props} renderChild={LayoutItemRaw} />;
};
